import * as moment from 'moment';
import { CustomerModules } from '../enums/customer-modules.enum';
import { CustomerInfo } from './customer-info.model';

export class CustomerResponse {
  data: Customer[];
  totalPages: number;
  totalRecords: number;
}

export class Customer {
  customer: CustomerInfo;
  modules: CustomerModules[];
  phone: string;
  firstDate: string;
  lastDate: string;
  modulesDescription: string;

  constructor(obj: any = {}) {
    Object.assign(this, obj);

    if (this.firstDate) {
      this.firstDate = moment(this.firstDate).format('DD/MM/YYYY');
    }
    if (this.lastDate) {
      this.lastDate = moment(this.lastDate).format('DD/MM/YYYY');
    }
    if (this.modules && this.modules.length > 0) {
      this.modulesDescription = '';
      for (let m of this.modules) {
        switch (m) {
          case CustomerModules.ORDER:
            this.modulesDescription += `${this.concatSeparator()}Pedidos`;
            break;

          case CustomerModules.QUEUE:
            this.modulesDescription += `${this.concatSeparator()}Fila`;
            break;

          case CustomerModules.BOOKING_TABLE:
            this.modulesDescription += `${this.concatSeparator()}Reserva`;
            break;

          default:
            break;
        }
      }
    }
    if (this.customer) {
      this.customer = new CustomerInfo(this.customer);
    }
  }

  concatSeparator(): string {
    if (!this.modulesDescription) return '';
    else return ', ';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/customers/models/customer.model.ts